export const LIST_DEFAULT_PAGE_SIZE = 100;
export const LIST_DEFAULT_SELECT = 999;
export const DEFAULT_STALE_TIME = 5 * 60 * 1000;
export const DEFAULT_GC_TIME = 0;